// Función helper para detectar si estamos en desarrollo
export const isDevelopment = () => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname.toLowerCase();
  const protocol = window.location.protocol;
  
  // Si es HTTPS, NUNCA es desarrollo
  if (protocol === 'https:') {
    return false;
  }
  
  // Solo localhost explícito es desarrollo
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0';
};

// Función helper para obtener la URL base del API
export const getApiBaseUrl = () => {
  // Si hay una variable de entorno, usarla (tiene prioridad)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Verificar que window y location estén disponibles
  if (typeof window === 'undefined' || !window.location || !window.location.hostname) {
    // Fallback seguro: asumir producción (ruta relativa)
    return '';
  }
  
  const protocol = window.location.protocol;
  const hostname = window.location.hostname.toLowerCase();
  
  // FORZAR producción si es HTTPS (nunca usar localhost en HTTPS público)
  if (protocol === 'https:') {
    return '';
  }
  
  // Detectar si estamos en desarrollo por hostname
  if (isDevelopment()) {
    return 'http://localhost:5002';
  }
  
  // En producción, usar ruta relativa
  return '';
};

// Función helper para construir URL completa del archivo
export const getFileUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  // Rutas de la carpeta public (ej. /images/...) se sirven por el mismo origen, no por el API
  if (path.startsWith('/images/')) {
    return path;
  }
  
  // Uploads: en producción usar /api/uploads (nginx a veces no sirve /uploads)
  if (path.startsWith('/uploads/')) {
    if (isDevelopment()) {
      const baseURL = getApiBaseUrl();
      return `${baseURL}${path}`;
    }
    if (typeof window !== 'undefined' && window.location?.origin) {
      return `${window.location.origin}/api${path}`;
    }
    return `/api${path}`;
  }

  if (isDevelopment()) {
    const baseURL = getApiBaseUrl();
    return `${baseURL}${path}`;
  }
  return path;
};

/**
 * Formatea una fecha YYYY-MM-DD en hora local (evita que 2026-03-05 se muestre como 4 de marzo por UTC).
 */
export const formatarFechaLocal = (fechaStr, options = { day: 'numeric', month: 'long', year: 'numeric' }) => {
  if (!fechaStr) return '';
  const partes = String(fechaStr).split(/[-T]/);
  const y = parseInt(partes[0], 10);
  const m = parseInt(partes[1], 10);
  const d = parseInt(partes[2], 10);
  if (!y || !m || !d || isNaN(y) || isNaN(m) || isNaN(d)) return new Date(fechaStr).toLocaleDateString('es-CO', options);
  const fecha = new Date(y, m - 1, d);
  return fecha.toLocaleDateString('es-CO', options);
};

/** Indica si una convocatoria está cerrada (fecha de cierre ya pasó). */
export const convocatoriaCerrada = (c) => {
  if (!c || !c.fecha_fin) return false;
  const hoy = new Date(new Date().setHours(0, 0, 0, 0));
  const [y, m, d] = String(c.fecha_fin).split(/[-T]/).map(Number);
  const cierre = y && m && d ? new Date(y, m - 1, d, 23, 59, 59) : new Date(c.fecha_fin);
  return cierre < hoy;
};













